import styled from 'styled-components';

const WarnButton = styled.button.attrs({
  className: 'flex justify-center py-5 px-30 mx-auto mb-5',
})`
  color: ${(props) =>
    props.isAlert ? 'rgb(241, 35, 35)' : 'rgb(232, 177, 44)'};
  background: ${(props) =>
    props.isAlert ? 'rgba(241, 35, 35, 0.1)' : 'rgba(232, 177, 44, 0.1)'};
  border-radius: 15px;
  font-size: 14px;
  line-height: 18px;
  height: auto;
`;

const AdContainer = styled.div.attrs({
  className: 'py-4 cursor-pointer',
})`
  overflow: hidden;

  img {
    border-radius: 0.5rem;
  }
`;

export { WarnButton, AdContainer };
